import API from "../../restAPI";
const Api = new API();

export default class LoginAPI {
  // Login api
  getLoginApi(payload) {
    return Api.request("/users/login", payload, "POST");
  }
}
